import React from 'react';
import styled from 'styled-components';
import { down } from 'styled-breakpoints';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import messages from './messages';

interface MarkCompleteButtonContentProps {
  intl: InjectedIntlProps;
  isComplete: boolean;
  isCourseDetail?: boolean;
  onlyIcons?: boolean;
  isUndo?: boolean;
}

interface StyleProps {
  isCourseDetail?: boolean;
  isComplete?: boolean;
  onlyIcons?: boolean;
}

const MarkCompleteContainer = styled.div<StyleProps>`
  display: flex;
  white-space: nowrap;
  color: ${({ isComplete, isCourseDetail }): string => {
    if (isComplete) return '#2ac278';
    if (isCourseDetail) return 'rgb(255, 255, 255)';
    return '#666';
  }};
  text-transform: none;
  font-family: ${({ theme: { fonts } }): string => fonts.sourceSans};
`;

const MarkCompleteIcon = styled.i<StyleProps>`
  font-size: ${({ theme: { fontSizes } }): string => fontSizes.f2};
  ${({ onlyIcons }): string => (onlyIcons ? '' : 'padding-right: 0.5rem')};

  &::before {
    color: ${({ onlyIcons, isComplete, isCourseDetail }): string => {
      if (isComplete || onlyIcons) return '';
      if (isCourseDetail) return 'rgb(255, 255, 255)';
      return '';
    }};
  }
`;

const MarkCompleteText = styled.span<StyleProps>`
  width: ${({ isCourseDetail }): string => (isCourseDetail ? '118px' : 'auto')};
  margin-right: ${({ isCourseDetail }): string => (isCourseDetail ? '20px' : '0px')};
  font-size: ${({ theme: { fontSizes } }): string => fontSizes.f3};
  font-family: ${({ theme: { fonts } }): string => fonts.sourceSans};
  display: ${({ onlyIcons }): string => (onlyIcons ? 'none' : 'block')};

  ${down('tablet-landscape')} {
    display: ${({ isCourseDetail }): string => (isCourseDetail ? 'none' : 'block')};
  }
`;

const MarkCompleteButtonContent: React.FC<MarkCompleteButtonContentProps & InjectedIntlProps> = ({
  isComplete,
  isCourseDetail = false,
  onlyIcons = false,
  intl,
  isUndo = true,
}) => {
  const message = messages[isComplete ? 'completed' : 'markAsComplete'];
  const { formatMessage } = intl;
  return (
    <MarkCompleteContainer isComplete={isComplete} isCourseDetail={isCourseDetail}>
      <MarkCompleteIcon
        className={`icon-check-${isComplete ? 'green' : 'mark-complete'}`}
        isComplete={isComplete}
        onlyIcons={onlyIcons}
        isCourseDetail={isCourseDetail}
        aria-hidden="true"
      />
      <MarkCompleteText
        isCourseDetail={isCourseDetail}
        onlyIcons={onlyIcons}
        data-id="button-mark-as-complete-text"
        aria-hidden="true"
      >
        {formatMessage(message)}
      </MarkCompleteText>
      {isComplete && isUndo && (
        <span className="red" data-id="mark-complete-undo" style={{ marginLeft: '35%' }}>
          {formatMessage(messages.undo)}
        </span>
      )}
    </MarkCompleteContainer>
  );
};

export default injectIntl(MarkCompleteButtonContent);
